import React from "react";
import { Link } from 'react-router-dom';

// Material UI
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// Icons
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";

// Components
import { DataGrid } from '@arredo/reactjs-ui';

import WrapperDatePicker from '../../../../components/wrapperDatapicker';
// Hooks
import useSellerSales from '../../../../hooks/billing/useSellerSales';

// Models
import { columns } from '../../../../models/SellerSaleEntity';

const SellerSales = () => {
    const { sellerSales, loading, filters, setFilters } = useSellerSales();

    const handleFilterChange = (event) => {
        setFilters({ ...filters, [event.target.name]: event.target.value });
    }

    return (
        <Grid container spacing={3}>
            <Grid
                size={{
                    xs: 12,
                    md: "grow"
                }}
            >
                <Typography variant='h4'>
                    Vendedores
                </Typography>
            </Grid>
            <Grid
                size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                }}
            >

                <WrapperDatePicker
                    filters={filters?.from}
                    handleFilterChange={handleFilterChange}
                    type="from"
                />
            </Grid>
            <Grid
                size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                }}
            >

                <WrapperDatePicker
                    filters={filters?.to}
                    handleFilterChange={handleFilterChange}
                    type="to"
                />
            </Grid>
            <Grid size={12}>
                <DataGrid
                    columns={columns}
                    rows={sellerSales}
                    loading={loading}
                    actions={({ row }) => (
                        <>
                            {
                                row.seller &&
                                <Tooltip title='Ver Facturas'>
                                    <IconButton
                                        component={Link}
                                        to={`/cashRegisters/invoices?sellerCode=${row.seller.code}&from=${filters.from}&to=${filters.to}`}
                                        size="large"
                                    >
                                        <ReceiptIcon />
                                    </IconButton>
                                </Tooltip>
                            }
                            {
                                row.seller &&
                                <Tooltip title='Ver Notas de Credito'>
                                    <IconButton
                                        component={Link}
                                        to={`/cashRegisters/vouchers?sellerCode=${row.seller.code}&from=${filters.from}&to=${filters.to}`}
                                        size="large"
                                    >
                                        <ReceiptOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                            }
                        </>
                    )}
                />
            </Grid>
        </Grid>
    );
}

export default SellerSales;